import { LocationForecastResponse } from './interfaces';

export const weatherDataMock: LocationForecastResponse = {
  type: 'Feature',
  geometry: {
    type: 'Point',
    coordinates: [10.485, 63.4309, 56],
  },
  properties: {
    meta: {
      updated_at: '2026-02-24T09:27:13Z',
      units: {
        air_pressure_at_sea_level: 'hPa',
        air_temperature: 'celsius',
        cloud_area_fraction: '%',
        precipitation_amount: 'mm',
        relative_humidity: '%',
        wind_from_direction: 'degrees',
        wind_speed: 'm/s',
      },
    },
    timeseries: [
      {
        time: '2026-02-24T10:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1019.1,
              air_temperature: -4.9,
              cloud_area_fraction: 3.6,
              relative_humidity: 74.7,
              wind_from_direction: 70,
              wind_speed: 2.6,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'clearsky_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'clearsky_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T11:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1019,
              air_temperature: -3.2,
              cloud_area_fraction: 2.4,
              relative_humidity: 69.2,
              wind_from_direction: 70,
              wind_speed: 3.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'clearsky_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'clearsky_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1018.9,
              air_temperature: -0.9,
              cloud_area_fraction: 1.4,
              relative_humidity: 56.2,
              wind_from_direction: 127,
              wind_speed: 3.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'clearsky_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'fair_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T13:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1018.6,
              air_temperature: -0.4,
              cloud_area_fraction: 0.1,
              relative_humidity: 54.3,
              wind_from_direction: 146,
              wind_speed: 4.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'clearsky_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T14:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1018.3,
              air_temperature: -0.5,
              cloud_area_fraction: 0.1,
              relative_humidity: 55,
              wind_from_direction: 146,
              wind_speed: 6.2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'clearsky_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T15:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1018.1,
              air_temperature: -0.9,
              cloud_area_fraction: 0.2,
              relative_humidity: 56.3,
              wind_from_direction: 148,
              wind_speed: 6.9,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'clearsky_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T16:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1018,
              air_temperature: -1.7,
              cloud_area_fraction: 1.7,
              relative_humidity: 57.9,
              wind_from_direction: 152,
              wind_speed: 7.5,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'clearsky_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T17:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1017.7,
              air_temperature: -2.2,
              cloud_area_fraction: 62.7,
              relative_humidity: 59.3,
              wind_from_direction: 150,
              wind_speed: 8.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1017.3,
              air_temperature: -2.2,
              cloud_area_fraction: 98.4,
              relative_humidity: 59.2,
              wind_from_direction: 153,
              wind_speed: 8.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightsleet',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T19:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1016.8,
              air_temperature: -2,
              cloud_area_fraction: 99.9,
              relative_humidity: 58.9,
              wind_from_direction: 157,
              wind_speed: 7.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightsleet',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T20:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1016,
              air_temperature: -1.6,
              cloud_area_fraction: 100,
              relative_humidity: 57.6,
              wind_from_direction: 158,
              wind_speed: 6.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightsleet',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T21:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1015.4,
              air_temperature: -1,
              cloud_area_fraction: 100,
              relative_humidity: 56,
              wind_from_direction: 164,
              wind_speed: 5.4,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'sleet',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T22:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1014.8,
              air_temperature: -0.4,
              cloud_area_fraction: 100,
              relative_humidity: 56.8,
              wind_from_direction: 164,
              wind_speed: 5.3,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'sleet',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-24T23:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1014.1,
              air_temperature: -0.1,
              cloud_area_fraction: 100,
              relative_humidity: 58,
              wind_from_direction: 169,
              wind_speed: 5.8,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'sleet',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-25T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1013.3,
              air_temperature: 0.2,
              cloud_area_fraction: 100,
              relative_humidity: 59.7,
              wind_from_direction: 160,
              wind_speed: 6.4,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'sleet',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'lightsleet',
            },
            details: {
              precipitation_amount: 0.6,
            },
          },
        },
      },
      {
        time: '2026-02-25T01:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1012.8,
              air_temperature: 0.5,
              cloud_area_fraction: 100,
              relative_humidity: 61,
              wind_from_direction: 171,
              wind_speed: 3.4,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'sleet',
            },
            details: {
              precipitation_amount: 1.7,
            },
          },
        },
      },
      {
        time: '2026-02-25T02:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1011.9,
              air_temperature: 1,
              cloud_area_fraction: 100,
              relative_humidity: 60.7,
              wind_from_direction: 165,
              wind_speed: 6.8,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'sleet',
            },
            details: {
              precipitation_amount: 3.6,
            },
          },
        },
      },
      {
        time: '2026-02-25T03:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1011.2,
              air_temperature: 1.2,
              cloud_area_fraction: 100,
              relative_humidity: 62.1,
              wind_from_direction: 164,
              wind_speed: 8.6,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'heavysleet',
            },
            details: {
              precipitation_amount: 5,
            },
          },
        },
      },
      {
        time: '2026-02-25T04:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1010.6,
              air_temperature: 1.4,
              cloud_area_fraction: 100,
              relative_humidity: 65.3,
              wind_from_direction: 165,
              wind_speed: 7.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'lightsleet',
            },
            details: {
              precipitation_amount: 0.2,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'heavysleet',
            },
            details: {
              precipitation_amount: 5.5,
            },
          },
        },
      },
      {
        time: '2026-02-25T05:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1009.8,
              air_temperature: 1.5,
              cloud_area_fraction: 100,
              relative_humidity: 66.9,
              wind_from_direction: 171,
              wind_speed: 8.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'sleet',
            },
            details: {
              precipitation_amount: 0.4,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'heavysleet',
            },
            details: {
              precipitation_amount: 5.5,
            },
          },
        },
      },
      {
        time: '2026-02-25T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1009.1,
              air_temperature: 1.4,
              cloud_area_fraction: 100,
              relative_humidity: 69.7,
              wind_from_direction: 175,
              wind_speed: 7.4,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'heavysleet',
            },
            details: {
              precipitation_amount: 1.2,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'heavysleet',
            },
            details: {
              precipitation_amount: 5.1,
            },
          },
        },
      },
      {
        time: '2026-02-25T07:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1008.7,
              air_temperature: 1.3,
              cloud_area_fraction: 100,
              relative_humidity: 81.4,
              wind_from_direction: 170,
              wind_speed: 7.4,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'heavysleet',
            },
            details: {
              precipitation_amount: 1.8,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 3.8,
            },
          },
        },
      },
      {
        time: '2026-02-25T08:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1008.1,
              air_temperature: 1.3,
              cloud_area_fraction: 100,
              relative_humidity: 83,
              wind_from_direction: 167,
              wind_speed: 7.3,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'heavysleet',
            },
            details: {
              precipitation_amount: 1.3,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 2.3,
            },
          },
        },
      },
      {
        time: '2026-02-25T09:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1007.3,
              air_temperature: 1.5,
              cloud_area_fraction: 100,
              relative_humidity: 82.3,
              wind_from_direction: 166,
              wind_speed: 8.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'sleet',
            },
            details: {
              precipitation_amount: 0.4,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 1.6,
            },
          },
        },
      },
      {
        time: '2026-02-25T10:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1006.6,
              air_temperature: 1.9,
              cloud_area_fraction: 100,
              relative_humidity: 79.2,
              wind_from_direction: 165,
              wind_speed: 7.5,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 0.9,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 1.2,
            },
          },
        },
      },
      {
        time: '2026-02-25T11:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1006.5,
              air_temperature: 2.3,
              cloud_area_fraction: 100,
              relative_humidity: 71.6,
              wind_from_direction: 172,
              wind_speed: 4.6,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 0.8,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 1.5,
            },
          },
        },
      },
      {
        time: '2026-02-25T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1006.4,
              air_temperature: 3,
              cloud_area_fraction: 100,
              relative_humidity: 67.6,
              wind_from_direction: 186,
              wind_speed: 3.5,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 0.6,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 1.8,
            },
          },
        },
      },
      {
        time: '2026-02-25T13:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1006.3,
              air_temperature: 3.1,
              cloud_area_fraction: 100,
              relative_humidity: 66.4,
              wind_from_direction: 185,
              wind_speed: 3.9,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 0.2,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 1.9,
            },
          },
        },
      },
      {
        time: '2026-02-25T14:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1006.6,
              air_temperature: 3.2,
              cloud_area_fraction: 100,
              relative_humidity: 76.8,
              wind_from_direction: 191,
              wind_speed: 3.5,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 0.3,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 1.8,
            },
          },
        },
      },
      {
        time: '2026-02-25T15:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1007.1,
              air_temperature: 3.2,
              cloud_area_fraction: 100,
              relative_humidity: 79.3,
              wind_from_direction: 186,
              wind_speed: 4.8,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 0.4,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 1.6,
            },
          },
        },
      },
      {
        time: '2026-02-25T16:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1007.8,
              air_temperature: 3.4,
              cloud_area_fraction: 100,
              relative_humidity: 81.7,
              wind_from_direction: 187,
              wind_speed: 5.2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 0.5,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 1.2,
            },
          },
        },
      },
      {
        time: '2026-02-25T17:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1008.7,
              air_temperature: 3.7,
              cloud_area_fraction: 100,
              relative_humidity: 85.7,
              wind_from_direction: 198,
              wind_speed: 3.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 0.3,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.8,
            },
          },
        },
      },
      {
        time: '2026-02-25T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1009.2,
              air_temperature: 3.7,
              cloud_area_fraction: 100,
              relative_humidity: 88.4,
              wind_from_direction: 189,
              wind_speed: 4,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 0.3,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.6,
            },
          },
        },
      },
      {
        time: '2026-02-25T19:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1009.4,
              air_temperature: 3.7,
              cloud_area_fraction: 100,
              relative_humidity: 88.1,
              wind_from_direction: 187,
              wind_speed: 3.9,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.2,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.6,
            },
          },
        },
      },
      {
        time: '2026-02-25T20:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1009.3,
              air_temperature: 3.6,
              cloud_area_fraction: 100,
              relative_humidity: 87.5,
              wind_from_direction: 179,
              wind_speed: 3.8,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.1,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.6,
            },
          },
        },
      },
      {
        time: '2026-02-25T21:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1009,
              air_temperature: 3.6,
              cloud_area_fraction: 100,
              relative_humidity: 87.9,
              wind_from_direction: 175,
              wind_speed: 3.9,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.1,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.6,
            },
          },
        },
      },
      {
        time: '2026-02-25T22:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1008.7,
              air_temperature: 3.5,
              cloud_area_fraction: 100,
              relative_humidity: 88,
              wind_from_direction: 172,
              wind_speed: 4.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.1,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.5,
            },
          },
        },
      },
      {
        time: '2026-02-25T23:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1008.2,
              air_temperature: 3.5,
              cloud_area_fraction: 100,
              relative_humidity: 87.3,
              wind_from_direction: 167,
              wind_speed: 4.4,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {
              precipitation_amount: 0.1,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1007.7,
              air_temperature: 3.3,
              cloud_area_fraction: 100,
              relative_humidity: 87.3,
              wind_from_direction: 157,
              wind_speed: 2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T01:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1007.1,
              air_temperature: 3,
              cloud_area_fraction: 100,
              relative_humidity: 88.4,
              wind_from_direction: 137,
              wind_speed: 0.8,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T02:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1006.1,
              air_temperature: 2.8,
              cloud_area_fraction: 100,
              relative_humidity: 89.5,
              wind_from_direction: 49,
              wind_speed: 1.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T03:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1004.9,
              air_temperature: 2.7,
              cloud_area_fraction: 100,
              relative_humidity: 89.9,
              wind_from_direction: 58,
              wind_speed: 2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T04:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1003.9,
              air_temperature: 2.5,
              cloud_area_fraction: 100,
              relative_humidity: 91.6,
              wind_from_direction: 70,
              wind_speed: 2.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T05:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1002.8,
              air_temperature: 2.4,
              cloud_area_fraction: 100,
              relative_humidity: 91.8,
              wind_from_direction: 75,
              wind_speed: 2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1001.7,
              air_temperature: 2.6,
              cloud_area_fraction: 100,
              relative_humidity: 89.6,
              wind_from_direction: 70,
              wind_speed: 1.8,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T07:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1000.6,
              air_temperature: 2.8,
              cloud_area_fraction: 100,
              relative_humidity: 87.7,
              wind_from_direction: 67,
              wind_speed: 1.6,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T08:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 999.6,
              air_temperature: 3.1,
              cloud_area_fraction: 100,
              relative_humidity: 84.2,
              wind_from_direction: 72,
              wind_speed: 1.6,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T09:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 998.5,
              air_temperature: 3.8,
              cloud_area_fraction: 100,
              relative_humidity: 81,
              wind_from_direction: 70,
              wind_speed: 1.3,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T10:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 997.9,
              air_temperature: 4.2,
              cloud_area_fraction: 100,
              relative_humidity: 80.4,
              wind_from_direction: 33,
              wind_speed: 0.7,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T11:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 997.7,
              air_temperature: 4.6,
              cloud_area_fraction: 100,
              relative_humidity: 80.5,
              wind_from_direction: 307,
              wind_speed: 0.8,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 997.2,
              air_temperature: 4.6,
              cloud_area_fraction: 100,
              relative_humidity: 85.6,
              wind_from_direction: 332,
              wind_speed: 0.9,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T13:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 996.9,
              air_temperature: 5.1,
              cloud_area_fraction: 97.6,
              relative_humidity: 84.7,
              wind_from_direction: 336,
              wind_speed: 1.4,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T14:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 996.8,
              air_temperature: 5.2,
              cloud_area_fraction: 90.4,
              relative_humidity: 88.5,
              wind_from_direction: 313,
              wind_speed: 0.7,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T15:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 996.7,
              air_temperature: 4.9,
              cloud_area_fraction: 96.5,
              relative_humidity: 89.8,
              wind_from_direction: 289,
              wind_speed: 0.7,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T16:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 996.6,
              air_temperature: 4.6,
              cloud_area_fraction: 93.9,
              relative_humidity: 91.3,
              wind_from_direction: 283,
              wind_speed: 0.4,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T17:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 996.5,
              air_temperature: 4.7,
              cloud_area_fraction: 91.1,
              relative_humidity: 78.9,
              wind_from_direction: 203,
              wind_speed: 1.8,
            },
          },
          next_1_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-26T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 996.4,
              air_temperature: 4.3,
              cloud_area_fraction: 91.4,
              relative_humidity: 79.4,
              wind_from_direction: 192,
              wind_speed: 2.3,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 2.7,
            },
          },
        },
      },
      {
        time: '2026-02-27T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 998.7,
              air_temperature: 3.4,
              cloud_area_fraction: 100,
              relative_humidity: 88.2,
              wind_from_direction: 154,
              wind_speed: 1.5,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-27T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 999.4,
              air_temperature: 2.7,
              cloud_area_fraction: 98.8,
              relative_humidity: 85.3,
              wind_from_direction: 155.1,
              wind_speed: 2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-27T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 997.8,
              air_temperature: 6.8,
              cloud_area_fraction: 100,
              relative_humidity: 69.4,
              wind_from_direction: 109.1,
              wind_speed: 2.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-27T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 996,
              air_temperature: 5.4,
              cloud_area_fraction: 100,
              relative_humidity: 79.3,
              wind_from_direction: 149.5,
              wind_speed: 2.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 2.3,
            },
          },
        },
      },
      {
        time: '2026-02-28T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 998.3,
              air_temperature: 4.8,
              cloud_area_fraction: 100,
              relative_humidity: 86,
              wind_from_direction: 204.4,
              wind_speed: 2.8,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 2.5,
            },
          },
        },
      },
      {
        time: '2026-02-28T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1006.2,
              air_temperature: 3.5,
              cloud_area_fraction: 100,
              relative_humidity: 84.8,
              wind_from_direction: 241.7,
              wind_speed: 4.2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-28T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1009.6,
              air_temperature: 5.1,
              cloud_area_fraction: 67.2,
              relative_humidity: 72.6,
              wind_from_direction: 240.9,
              wind_speed: 3.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-02-28T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1014.2,
              air_temperature: 2.7,
              cloud_area_fraction: 39.8,
              relative_humidity: 79.8,
              wind_from_direction: 195,
              wind_speed: 2.9,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-01T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1014.8,
              air_temperature: 1.2,
              cloud_area_fraction: 21.9,
              relative_humidity: 76.2,
              wind_from_direction: 167.6,
              wind_speed: 2.6,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'fair_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-01T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1013,
              air_temperature: -0.2,
              cloud_area_fraction: 96.1,
              relative_humidity: 73.5,
              wind_from_direction: 153,
              wind_speed: 2.6,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-01T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1010.9,
              air_temperature: 5,
              cloud_area_fraction: 77.3,
              relative_humidity: 60.7,
              wind_from_direction: 152.4,
              wind_speed: 2.2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-01T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1010.1,
              air_temperature: 3.6,
              cloud_area_fraction: 93.7,
              relative_humidity: 73.2,
              wind_from_direction: 158.3,
              wind_speed: 2.9,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-02T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1010.7,
              air_temperature: 2.3,
              cloud_area_fraction: 98.4,
              relative_humidity: 77.6,
              wind_from_direction: 165.4,
              wind_speed: 2.2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-02T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1010.8,
              air_temperature: 2.2,
              cloud_area_fraction: 100,
              relative_humidity: 79.9,
              wind_from_direction: 165,
              wind_speed: 2.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-02T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1011.6,
              air_temperature: 6,
              cloud_area_fraction: 100,
              relative_humidity: 67.5,
              wind_from_direction: 113.5,
              wind_speed: 2.2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-02T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1010,
              air_temperature: 5.4,
              cloud_area_fraction: 100,
              relative_humidity: 77.1,
              wind_from_direction: 151.6,
              wind_speed: 2.8,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-03T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1007.1,
              air_temperature: 5.6,
              cloud_area_fraction: 99.2,
              relative_humidity: 77.2,
              wind_from_direction: 159.1,
              wind_speed: 2.9,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-03T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1006.6,
              air_temperature: 4.1,
              cloud_area_fraction: 88.3,
              relative_humidity: 77.1,
              wind_from_direction: 188.7,
              wind_speed: 3.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-03T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1007.6,
              air_temperature: 6.6,
              cloud_area_fraction: 88.3,
              relative_humidity: 70.3,
              wind_from_direction: 197.4,
              wind_speed: 2.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_day',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-03T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1008.6,
              air_temperature: 5.1,
              cloud_area_fraction: 64.1,
              relative_humidity: 77.8,
              wind_from_direction: 196.4,
              wind_speed: 2.7,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-04T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1008.1,
              air_temperature: 3.9,
              cloud_area_fraction: 89.1,
              relative_humidity: 74.4,
              wind_from_direction: 165.6,
              wind_speed: 3,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-04T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1005.5,
              air_temperature: 3.1,
              cloud_area_fraction: 100,
              relative_humidity: 76.6,
              wind_from_direction: 162.1,
              wind_speed: 3.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-04T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1004.9,
              air_temperature: 6.5,
              cloud_area_fraction: 100,
              relative_humidity: 68.3,
              wind_from_direction: 166.5,
              wind_speed: 3.5,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-04T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1000,
              air_temperature: 4.5,
              cloud_area_fraction: 99.2,
              relative_humidity: 78.2,
              wind_from_direction: 162.9,
              wind_speed: 3.2,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'lightrain',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'rain',
            },
            details: {
              precipitation_amount: 3.4,
            },
          },
        },
      },
      {
        time: '2026-03-05T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 997.9,
              air_temperature: 3.7,
              cloud_area_fraction: 100,
              relative_humidity: 86.8,
              wind_from_direction: 194.9,
              wind_speed: 3.1,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-05T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 999.4,
              air_temperature: 3.1,
              cloud_area_fraction: 99.6,
              relative_humidity: 82.1,
              wind_from_direction: 163,
              wind_speed: 2.9,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-05T12:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1002,
              air_temperature: 6,
              cloud_area_fraction: 100,
              relative_humidity: 69.8,
              wind_from_direction: 246.2,
              wind_speed: 3.3,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-05T18:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1003.5,
              air_temperature: 3.9,
              cloud_area_fraction: 99.2,
              relative_humidity: 79.7,
              wind_from_direction: 156.2,
              wind_speed: 3.8,
            },
          },
          next_12_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {},
          },
          next_6_hours: {
            summary: {
              symbol_code: 'cloudy',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-06T00:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1004.8,
              air_temperature: 3.4,
              cloud_area_fraction: 68.7,
              relative_humidity: 76.5,
              wind_from_direction: 154.6,
              wind_speed: 3.6,
            },
          },
          next_6_hours: {
            summary: {
              symbol_code: 'partlycloudy_night',
            },
            details: {
              precipitation_amount: 0,
            },
          },
        },
      },
      {
        time: '2026-03-06T06:00:00Z',
        data: {
          instant: {
            details: {
              air_pressure_at_sea_level: 1003.4,
              air_temperature: 2.4,
              cloud_area_fraction: 98.4,
              relative_humidity: 75.8,
              wind_from_direction: 161.5,
              wind_speed: 3.4,
            },
          },
        },
      },
    ],
  },
} satisfies LocationForecastResponse;
